import { get, merge } from 'lodash';
import { resolve } from 'redux-optimist-promise';
import { addTranslationKeys } from 'Src/i18n';
import { SET_CMS, GET_BOOKING_ENGINE_I18N } from './cms.actions';
type State = {};
const initialState: State = {};
export default function cmsReducer(state: State = initialState, action: Action<any>): State {
  switch (get(action, 'type')) {
    case resolve(GET_BOOKING_ENGINE_I18N):
    case SET_CMS: {
      const data = merge({}, state, {
        ...get(action, 'payload.config', {}),
        // This is the cost of legacy. If there is a recomposition to do, it should be done on the
        // graphql server.
        ...get(action, 'payload.legalInformations', {}),
        paymentProviders: get(action, 'payload.paymentProviders', {}),
      });
      addTranslationKeys(data);
      return data;
    }

    default:
      return state;
  }
}
